import { useQuery } from "react-query";
import Network from "../../network";

export default function useLibrary(libraryCode: string) {

    const {data, isLoading, error} = useQuery(['library', libraryCode], () => Network.getLibrary({
        code: libraryCode
    }), {
        staleTime: Infinity
    });

    return {
        library: data,
        isLoading,
        error
    }
}
